/**
 * This is a sample of a store using Pinia.
 *
 * You can name the return value of `defineStore()` anything you want,
 * but it's best to use the name of the store and surround it with `use`
 * and `Store` (e.g. `useUserStore`, `useCartStore`, `useProductStore`)
 * the first argument is a unique id of the store across your application
 *
 * > https://pinia.vuejs.org/core-concepts/#defining-a-store
 */

import { defineStore } from 'pinia';
import { type Ref, ref } from 'vue';

// https://pinia.vuejs.org/core-concepts/#setup-stores
export const useSampleStore = defineStore('sample', () => {
  const inputValue: Ref<string> = ref('');
  const set = (value: string) => {
    inputValue.value = value;
  };

  return {
    inputValue,
    set,
  };
});
